import i18next from 'i18next'
import React from 'react'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { ProfileNameEditorProps } from './interfaces'
import css from './ProfileNameEditor.module.css'

export const ProfileNameEditor = ({
	handleEditName,
	handleNameTextChange,
	handleNameChange,
	profileInputState
}: ProfileNameEditorProps): React.ReactElement => {
	const {
		profile: { userId, gravatarUrl }
	} = useSelector((state: ApplicationState) => state)

	return (
		<div className={css['profile_edit_container']}>
			{!userId && (
				<React.Fragment>
					<div className={css['profile_edit_button_container']}>
						<button onClick={handleEditName}>{i18next.t('pages.litb.signIn')}</button>
					</div>
					<div className={css['or']}>
						<span>{i18next.t('pages.litb.or')}</span>
					</div>
				</React.Fragment>
			)}
			<div className={css['profile_edit_text_container']}>
				<input onChange={handleNameTextChange} value={profileInputState} />
				<img alt="Profile" onClick={handleNameChange} src={gravatarUrl} />
			</div>
		</div>
	)
}
